export const ethinicity = [
    "Asian",
    "Black / African American",
    "Hispanic / Latino",
    "Native American / Alaska Native",
    "Pacific Islander",
    "Caucasian / White",
    "Other",
    "I'd rather not say"
]